import {
  CATEGORY_PAGE_LINK_REGEX,
} from '../category/categoryConstants';

import {
  LANDING_PAGE_LINK_REGEX,
} from './landingPageConstants';

function findCategoryLandingPage(landingPages, categoryId, environment) {
  return landingPages?.find((landingPage) => {

    const landingPageCategoryId = landingPage.url.match(CATEGORY_PAGE_LINK_REGEX)?.[2];

    return landingPageCategoryId === categoryId &&
      landingPage.environment === environment;
  });
}

function findLandingPage(landingPages, dynamicId, environment) {
  return landingPages?.find((landingPage) => {

    const landingPageId = landingPage.url.match(LANDING_PAGE_LINK_REGEX)?.[2];

    return landingPageId === dynamicId &&
      landingPage.environment === environment;
  });
}

export {
  findLandingPage,
  findCategoryLandingPage,
}
